const initSectorListingByCategory = () => {
    const sectorListingByCategoryWidgetList = document.querySelectorAll(".sector-listing-by-category-widget");
    if (sectorListingByCategoryWidgetList && sectorListingByCategoryWidgetList.length > 0) {
        sectorListingByCategoryWidgetList.forEach((sectorListingByCategoryWidge) => {
            const dataCarousel = sectorListingByCategoryWidge.querySelector("[data-carousel]");
            if (dataCarousel) {
                initCarousel(".sector-listing-category-card-deck[data-carousel]", cellAlign.center, true, false, true, false, true, 1024, true);
            }
        });
    }
};
